import { FormHelperText, TextField } from '@mui/material';

const NombrePropioTextInput = ({
  fieldName,
  label,
  register,
  errors,
  required,
  variant,
  maxLength,
  minLength,
  sx,
  error,
  helperText,
  InputProps,
}) => {
  return (
    <>
      <TextField
        variant={variant}
        fullWidth
        name={fieldName}
        label={label}
        type='text'
        id={fieldName}
        sx={sx}
        InputProps={InputProps}
        {...register(fieldName, {
          required: {
            value: required,
            message: 'Debe ingresar ' + label,
          },
          maxLength: {
            value: maxLength,
            message: label + ' debe tener como máximo ' + maxLength + ' caracteres.',
          },
          minLength: {
            value: minLength,
            message: label + ' debe tener como mínimo ' + minLength + ' caracteres.',
          },
          pattern: {
            value: /^(([a-záéíóúñA-ZÁÉÍÓÚÑ ]{2,40}))$/,
            message: 'El formato no es correcto.',
          },
        })}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
      {!error && errors[fieldName] && <p style={{ color: 'red' }}>{errors[fieldName].message}</p>}
    </>
  );
};

NombrePropioTextInput.defaultProps = {
  maxLength: 40,
  minLength: 2,
  variant: 'standard',
};
export default NombrePropioTextInput;
